import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { StartImport } from '../components/StartImport';

import { beginImport } from '../services/actions';
import { selectImportInProcessFlag } from '../services/selectors';

export default connect(
    state => ({
        importInProgress: selectImportInProcessFlag(state),
    }),
    dispatch => ({
        beginImport: bindActionCreators(beginImport, dispatch),
    }),
)(StartImport);
